import { GLOBAL_OBJ } from '@sentry/utils';
const WINDOW = GLOBAL_OBJ;
export { WINDOW };